import SDCheckbox from '@/shared/components/SDComponentsNewDesign/SDCheckbox/SDCheckbox'
import { LABEL_PLACEMENT } from 'baseui/checkbox'
import useAddress from '@/containers/SubscriptionFormPageNew/Components/Address/useAddress'

const EditAddressFields = () => {
  const { t, showAddressFields: showAddressFieldsValue, updateAddressesConfigHandler } = useAddress()

  return (
    <SDCheckbox
      kind='switch'
      checked={showAddressFieldsValue}
      onChange={value => updateAddressesConfigHandler({ showAddressFields: value })}
      labelPlacement={LABEL_PLACEMENT.right}
      label={t('common:edit_address_fields')}
    />
  )
}

export default EditAddressFields
